export const SURVEY_COVERAGE_FAVOURITE_TYPE = 'survey-coverage';

export function resolveGeoJsonEndPointUrl(
  endPoint: string | null | undefined,
): string | undefined {
  if (typeof endPoint !== 'string') {
    return undefined;
  }
  const trimmed = endPoint.trim();
  if (!trimmed) {
    return undefined;
  }
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }
  const apiBase = (process.env.REACT_APP_API_URL ?? '').replace(/\/$/, '');
  const path = trimmed.replace(/^\//, '');
  return apiBase ? `${apiBase}/${path}` : path;
}

export function isSurveyCoverageFavouriteNode(node: {
  readonly type?: string;
  readonly endPoint?: string;
  readonly endpoint?: string;
}): boolean {
  if (node.type === SURVEY_COVERAGE_FAVOURITE_TYPE) {
    return true;
  }
  const endPoint = node.endPoint ?? node.endpoint;
  return (
    typeof endPoint === 'string' &&
    /^https?:\/\//i.test(endPoint) &&
    endPoint.includes('outputFormat=')
  );
}
